var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",style:(_vm.styleBackground)},[_c('div',{staticClass:"main-content",attrs:{"id":"panel"}},[_c('dashboard-navbar'),_c('dashboard-header'),_c('dashboard-content'),_c('dashboard-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }